/* eslint-disable react/jsx-props-no-spreading */

"use client";

import { useSelector } from "react-redux";

import RenewalDocument from "@/components/molecules/renewals/review/document-section/document-section";
import PostalSetting from "@/components/molecules/review-section/postal-settings";
import { DocumentSectionTypes } from "@/schema/renewal-page/review-page.schema";
import { RootState } from "@/store/root-reducer";

type PolicyDocumentSectionProps = {
  content: DocumentSectionTypes;
};

export function PolicyDocumentSection({
  content,
}: Readonly<PolicyDocumentSectionProps>) {
  const { postalSettingConfirmationModal, postalSetting } = content;
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { organiser } = attributes;

  return (
    <div className="md:p-spacing-xxl p-spacing-m pb-spacing-l">
      <h1
        className="font-header-font md:text-[31px] text-[23px]
          md:leading-custom-size-xl leading-[28px] text-text-title mb-spacing-m md:mb-spacing-l"
      >
        {content.documentSection.documentsTitle}
      </h1>

      <div>
        <p className="text-text-body font-body-font text-2xs leading- [24px] font-[400] mb-spacing-m md:mb-spacing-l">
          {content.documentSection.emailText}{" "}
          <strong className="font-[700] text-text-on-secondary">
            {organiser?.email}
          </strong>{" "}
        </p>
        <RenewalDocument documentSectionContent={content.documentSection} />
      </div>
      <div>
        <PostalSetting
          {...{ ...postalSetting, ...postalSettingConfirmationModal }}
        />
      </div>
    </div>
  );
}
